import React, { useState, useEffect, useContext } from "react";
import { UserContext, Utils } from "../../common";
import { Modal } from "react-bootstrap";

const HelpVideos = () => {
  const [help, setHelp] = useState(false);
  const [hvs, setHvs] = useState(false);
  const { getHelpVideos } = useContext(UserContext);
  const [showModule, setShowModule] = useState(false);

  useEffect(() => {
    if (hvs === false) {
      getHelpVideos().then((mods) => setHvs(mods));
    }
  }, []);

  const renderHelpModule = () => {
    return (
      <Modal show={true} size="lg">
        <Modal.Body className="m-0 p-0 help-module">
          <button className="closeBtn" onClick={() => setShowModule(false)}>
            X
          </button>
          <p className="p-2 mt-4">{showModule.details}</p>
          <iframe
            height="350"
            width="100%"
            className="bg-dark"
            src={showModule.videourl}
            frameborder="0"
            allowFullScreen
            allow="encrypted-media"
          ></iframe>
        </Modal.Body>
      </Modal>
    );
  };

  return (
    <>
      {hvs !== false && hvs.length > 0 && (
        <>
          {help === false && (
            <button className="help-video closeBtn" onClick={() => setHelp(true)}>
              <img src={`${process.env.PUBLIC_URL}/images/help-video.png`} width={25} /> How To
            </button>
          )}
          {help === true && (
            <div className="help-video expanded">
              <button className="closeBtn" onClick={() => setHelp(false)}>
                X
              </button>
              <div className="m-4 mt-3 me-5">
                <div className="title">Let's Get You Started</div>
                <div>Know How To Use Denttrack Modules</div>
              </div>
              <div className="modules">
                {hvs.map((hv) => (
                  <div className="module" title={`Help for ${hv.title}`} onClick={() => setShowModule(hv)}>
                    <div />
                    {hv.title}
                  </div>
                ))}
              </div>
            </div>
          )}
          {showModule !== false && renderHelpModule()}
        </>
      )}
    </>
  );
};

export default HelpVideos;
